import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'

import type { HeaderClockProps } from './HeaderClock.props'

export function HeaderClock({ ...props }: HeaderClockProps) {
  const [time, setTime] = useState({
    hours: moment().format('HH'),
    minutes: moment().format('mm'),
    seconds: moment().format('ss'),
  })

  useEffect(() => {
    const timerID = setInterval(() => {
      setTime({
        hours: moment().format('HH'),
        minutes: moment().format('mm'),
        seconds: moment().format('ss'),
      })
    }, 1000)
    return () => clearInterval(timerID)
  }, [])

  return (
    <div className="header__time">
      <span className="header__hours">{time.hours}</span>
      <span className="header__minutes">{time.minutes}</span>
      <span className="header__seconds">{time.seconds}</span>
    </div>
  )
}
